module.exports = __webpack_public_path__ + "static/img/tavern.84a0568d.png";